<template>
  <input
    class="ax--input"
    v-model="inputValue"
    v-on:input="inputChanged"
    :class="{ 'no-border': border === 'none', 'ax--border': border === 'solid' }"
    :autofocus="autofocus"
    :type="type"
    :inputmode="inputmode"
    @keyup.enter="keyupEnter"
  />
</template>

<script>
export default {
  name: 'ax-input',
  model: {
    event: 'value-changed',
  },
  data() {
    return {
      inputValue: this.value,
    }
  },
  methods: {
    inputChanged() {
      if (this.inputmode === 'decimal') {
        this.inputValue = this.inputValue.replace(/[^\d.]/g, '').replace(/(\.[\d]{2})./g, '$1')
      }
      this.$emit('value-changed', this.inputValue)
    },
    keyupEnter() {
      this.$emit('value-changed', this.inputValue)
      this.$emit('enterKey')
    },
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    border: {
      type: String,
      default: 'solid',
      validator: (value) => {
        const borderValues = ['solid', 'none']
        return borderValues.includes(value)
      },
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'text',
    },
    inputmode: {
      type: String,
      default: 'text',
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue, oldValue) {
        this.inputValue = newValue
      },
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../../Content/scss/config';
@import '../../../Content/scss/lib/functions';

.ax--input {
  padding: pxrem(16);
  &__label {
    color: $color-label;
    display: block;
    text-transform: uppercase;
    line-height: 3; // A standard font size (16px) equates to 48px toll for this label. assumes no line wrapping
    font-size: pxrem(16);

    &--center {
      text-align: center;
      justify-content: center;
    }

    &--lowercase {
      text-transform: lowercase;
    }

    span {
      float: right;
    }
  }
}

.ax--border--rounded {
  border-radius: 3px;
}

.ax--border {
  border: 1px solid $color-primary;
}

.mbsc-ios.mbsc-fr-inline .mbsc-fr-w {
  border-top: none;
}
</style>
